var THREE;
var sid = 0;
function GameObject(data, overrideSid = null, saveData = true) {
  if (saveData) {
    this._initData = data;
  }
  this.sid = overrideSid || sid++;
  this.uid = data.uid;
  this.width = data.w;
  this.length = data.l;
  this.height = data.h;
  this.minScale = Math.max(data.w || 0, Math.max(data.l || 0, data.h || 0));
  this.collT = data.col || null;
  this.active = !data.startClosed && !data.startDestroyed;
  this.x = data.x;
  this.orgX = this.x;
  this.y = data.y;
  this.orgY = this.y;
  this.z = data.z;
  this.orgZ = this.z;
  this.xR = data.xR;
  this.yR = data.yR;
  this.zR = data.zR;
  this.dir = data.d;
  this.forceDir = data.fd;
  this.src = data.src;
  this.ramp = data.ramp;
  this.ladder = data.ladder;
  this.jumpPad = data.jumpPad;
  this.noShoot = data.noShoot;
  this.stepSrc = data.s;
  this.score = data.score;
  this.scoreP = data.scoreP;
  this.kill = data.kill;
  this.dummy = data.dummy;
  this.noVis = data.noVis;
  this.complexMesh = data.complexMesh;
  this.penetrable = data.penetrable;
  this.health = data.health;
  this.startHealth = data.health;
  this.canDestroy = data.canDestroy;
  this.transparent = data.transparent;
  this.boost = data.boost;
  this.boostDr = data.boostDr;
  this.aoMlt = data.aoM;
  this.team = data.team;
  this.flag = data.flag;
  this.flagTimer = 0;
  this.img = {
    x: data.x,
    y: data.y,
    z: data.z,
  };
  this.trigger = data.trigger;
  this.pickup = data.pickup;
  this.orgPickup = data.orgPickup;
  this.pickupRep = data.pickupRep;
  this.pickupRand = data.pickupRand;
  this.meshRef = data.meshRef;
  this.checkpoint = data.checkpoint;
  this.singleUse = data.singleUse;
  this.isBorder = data.isBorder;
  this.node = data.node;
  this.channel = data.channel;
  this.teleporter = data.teleporter;
  this.telCooldown = 0;
  this.propID = data.propID;
  this.telStopMo = data.momentum;
  this.noAmb = data.noAmb;
  this.tRadius = data.tRadius;
  this.gate = data.gate;
  this.noMsg = data.noMsg;
  this.method = data.method;
  this.closeable = data.closeable;
  this.startClosed = data.startClosed;
  this.startDestroyed = data.startDestroyed;
  this.selfDestruct = data.selfDestruct;
  this.triggerAction = data.action;
  this.triggerChance = data.chance;
  this.triggerConstant = data.constant;
  this.triggerConstantTxt = data.constantTxt;
  this.triggerSound = data.tSound;
  this.triggerConstantEvent = data.constantEvent || 0;
  this.triggerTimer = (data.constantEvent || 1) * 1000;
  this.onInteractT = (data.constantEvent || 1) * 1000;
  this.onColT = (data.constantEvent || 1) * 1000;
  if (data.eventN) {
    this[data.eventN] = true;
  }
  var m =
    data.respawnT != 0 && data.respawnT != null && data.respawnT < 100
      ? 100
      : data.respawnT;
  this.respawnT = m;
  this.respawnR = data.respawnR;
  this.respawnTStart = m;
  this.canRespawn = !!data.respawnR || !!m;
  this.destroyedBy = null;
  this.destroyed = false;
  this.interface = data.interface;
  this.interfaceT = data.interfaceT;
  this.deposited = 0;
  this.withdrawAmnt = data.withdraw;
  this.depositAmnt = data.deposit;
  this.bank = data.bank;
  this.objLink = data.objLink;
  this.showAd = data.showAd;
  this.isEvent = data.isEvent;
  this.terminal = data.terminal;
  this.premium = data.premium;
  this.verified = data.verified;
  this.teamZ = data.teamZ;
  this.assetID = data.asset;
  this.bounce = data.bounce;
  this.crouch = data.crouch;
  this.collT = data.collT;
  this.spin = data.spin;
  this.gravity = data.gravity;
  this.isDynamic = data.dynamic;
  this.type = data.type;
  this.storage = 0;
  this.lastColT = 0;
  this.triggered = false;
  this.wallJumpable = data.wallJumpable;
}
module.exports.GameObject = GameObject;
module.exports.manager = function (RENDER, UTILS, SOUND, prefabs, config) {
  var x;
  var y;
  if (RENDER) {
    THREE = require("three");
    require("../libs/CSS3DRenderer.js")(THREE);
  }
  this.aoOpac = 0;
  this.objects = [];
  this.pendingAIs = [];
  this.grids = {};
  this.objectives = [];
  this.sites = [];
  this.flags = [];
  this.spawnables = [];
  this.pickups = [];
  this.destObjs = [];
  this.gates = [];
  this.banks = [];
  this.interfaces = [];
  this.terminals = [];
  this.teleporters = [];
  this.timerObjs = [];
  this.spectateCams = {};
  this.collision = function (F, G, H) {
    return (
      F.x - F.width - H <= G.x + G.width &&
      F.x + F.width + H >= G.x - G.width &&
      F.z - F.length - H <= G.z + G.length &&
      F.z + F.length + H >= G.z - G.length &&
      F.y - F.height - H <= G.y + G.height &&
      F.y + F.height + H >= G.y - G.height
    );
  };
  this.genQuads = function () {
    Date.now();
    var F;
    var G;
    var H;
    var I;
    var J;
    var K;
    for (var L = 0; L < this.objects.length; ++L) {
      var M = (x = this.objects[L]).width + config.playerHeight + 0.1;
      var N = x.length + config.playerHeight + 0.1;
      var O = x.height + config.playerHeight + 0.1;
      F = Math.floor((x.x - M) / config.quadSize);
      G = Math.floor((x.x + M) / config.quadSize);
      H = Math.floor((x.z - N) / config.quadSize);
      I = Math.floor((x.z + N) / config.quadSize);
      J = Math.floor((x.y - O) / config.quadSize);
      K = Math.floor(
        (x.y + O + (x.isBorder ? config.borderH : 0)) / config.quadSize,
      );
      for (var P = F; P <= G; ++P) {
        for (var Q = H; Q <= I; ++Q) {
          for (var R = J; R <= K; ++R) {
            0;
            var S = P + "_" + R + "_" + Q;
            this.grids[S] ||= [];
            this.grids[S].push(x);
          }
        }
      }
    }
  };
  this.getGridArrays = function (F, G, H) {
    var I = Math.floor(F / config.quadSize);
    var J = Math.floor(G / config.quadSize);
    var K = Math.floor(H / config.quadSize);
    if (this.grids[I + "_" + J + "_" + K]) {
      return this.grids[I + "_" + J + "_" + K];
    }
  };
  this.checkPos = function (F, G, H, I, J) {
    for (var K = 0; K < this.objects.length; ++K) {
      if (
        this.objects[K] != I &&
        this.objects[K] != J &&
        !this.objects[K].ramp &&
        UTILS.pointInBox3D(F, G, H, this.objects[K])
      ) {
        return false;
      }
    }
    return true;
  };
  this.findByUid = function (F, G) {
    x = G || this.objects;
    for (var H = 0; H < x.length; ++H) {
      if (x[H].uid === F) {
        return x[H];
      }
    }
    return null;
  };
  this.findBySid = function (F, G) {
    x = G || this.objects;
    for (var H = 0; H < x.length; ++H) {
      if (x[H].sid === F) {
        return x[H];
      }
    }
    return null;
  };
  this.getZoneDat = function (F, G) {
    return {
      src: "zone_r",
      texSrc: "zone_" + (G && F == G.team ? "b" : "r"),
      noGroup: true,
      forceTex: true,
      mat: THREE.MeshBasicMaterial,
      transparent: true,
      depthWrite: false,
      side: 2,
      autoMatrix: true,
    };
  };
  this.getFlagDat = function (F, G) {
    var H = G && F == G.team ? "1" : "0";
    return {
      src: "crystal_0",
      texSrc: "crystal_" + H,
      noGroup: true,
      noShadow: true,
      noFog: true,
      emissive: H == "0" ? 8729652 : 4360861,
      noEmisTex: true,
    };
  };
  this.addFlag = function (F, G, H, I) {
    var J = null;
    if (RENDER) {
      (J = RENDER.loadMesh(
        this.getFlagDat(I),
        F,
        G + config.flagOff,
        H,
        0,
        config.flagScale,
        RENDER.scene,
      )).zoneMesh = RENDER.addCube(
        F,
        G,
        H,
        config.flagZoneS,
        config.flagZoneH,
        config.flagZoneS,
        [1, 1, 0, 0, 1, 1],
        this.getZoneDat(I),
      );
    }
    var K = new GameObject({
      uid: this.objects.length,
      meshRef: J,
      x: F,
      z: H,
      y: G + config.flagScale / 2 + config.flagOff,
      w: config.flagScale,
      l: config.flagScale,
      h: config.flagScale / 2,
      team: I,
      flag: true,
      noShoot: true,
      complexMesh: true,
    });
    this.flags.push(K);
    this.objects.push(K);
    var L = new GameObject({
      x: F,
      z: H,
      y: G + config.flagZoneH / 2,
      w: config.flagZoneS / 2,
      l: config.flagZoneS / 2,
      h: config.flagZoneH / 2,
      team: I,
      trigger: true,
      noShoot: true,
      complexMesh: true,
    });
    L.flagObj = K;
    this.objects.push(L);
  };
  this.addPad = function (F, G, H, I, J) {
    I = I || {};
    var K = null;
    if (RENDER && !I.noVis) {
      K = RENDER.loadMesh(
        {
          src: "pad_0",
          shadows: true,
          shadowsR: true,
          vertexColors: THREE.VertexColors,
          side: 2,
        },
        F,
        G,
        H,
        J,
        4,
        RENDER.scene,
      );
    }
    var L = new GameObject({
      uid: this.objects.length,
      meshRef: K,
      x: F,
      z: H,
      y: G,
      w: 5,
      l: 5,
      h: 1,
      xR: I.xR,
      yR: I.yR,
      zR: I.zR,
      jumpPad: true,
      bounce: I.bounce || 1,
      crouch: I.crouch,
      complexMesh: true,
    });
    this.objects.push(L);
  };
  this.addWeapon = function (F, G, H, I, J, K, L, M) {
    var N = null;
    if ((I = I || {}).weaponId == 12) {
      I.weaponId = 0;
    }
    if (
      typeof I.weaponId != "number" ||
      !Number.isFinite(I.weaponId) ||
      !M[I.weaponId]
    ) {
      console.warn("Invalid weapon pickup, falling back to weapon 0", {
        weaponId: I.weaponId,
        scoreP: I.scoreP,
        noMsg: I.noMsg,
        method: I.method,
        random: I.random,
        team: I.team,
      });
      I.weaponId = 0;
    }
    if (RENDER) {
      (N = RENDER.loadMesh(
        {
          src: "weapons/" + M[I.weaponId].src,
          texSrc: "weapons/" + M[I.weaponId].src,
          tFilter: THREE.LinearFilter,
          noGroup: true,
          uv2: true,
          shininess: M[I.weaponId].shine || 60,
          specular: 2697513,
          shadowsR: true,
          transparent: M[I.weaponId].seeThrough,
          emissive: M[I.weaponId].transp ? 16777215 : null,
        },
        F,
        G + config.pickupOff,
        H,
        0,
        M[I.weaponId].scale * (M[I.weaponId].equipment ? 2 : 1),
        RENDER.scene,
      )).visible = false;
      N.rotateY(J || 0);
      N.rotateX((K || 0) - (M[I.weaponId].equipment ? 0 : Math.PI / 2));
      N.rotateZ((L || 0) - (M[I.weaponId].equipment ? Math.PI / 2 : 0));
    }
    var O = new GameObject({
      uid: this.objects.length,
      meshRef: N,
      x: F,
      z: H,
      y: G + config.pickupZoneH / 2,
      w: config.pickupZoneX,
      l: config.pickupZoneZ,
      h: config.pickupZoneH * 2,
      pickup: I.weaponId,
      pickupRep: !I.noRep,
      orgPickup: I.weaponId,
      scoreP: I.scoreP,
      noMsg: I.noMsg,
      method: I.method,
      trigger: true,
      noShoot: true,
      complexMesh: true,
      pickupRand: I.random,
      team: I.team,
    });
    this.pickups.push(O);
    this.objects.push(O);
  };
  this.addShowcase = function (F, G, H, I, J, K, L, M, N, O) {
    if ((M = M || {}).mSize) {
      M.mSize = UTILS.limitMM(M.mSize, 0.1, 100);
    }
    G += K;
    var P = O.skins[M.itemID || 0];
    if (P && (!P || !P.type || (P.type != 4 && P.type != 5))) {
      if (!P.type) {
        O.previews[P.weapon];
      }
      var Q = N[P.weapon - 1] || {};
      if ((!RENDER || !!RENDER.mapDet) && !!RENDER) {
        RENDER.loadMesh(
          {
            src:
              O.types[P.type || 0] +
              (P.type ? P.id : P.weapon) +
              (P.mid == null ? "" : "_" + P.mid),
            texSrc:
              P.mid == null
                ? P.type && P.type == 3
                  ? P.pat
                    ? P.tex
                    : "melee/melee_" + (P.id || 0) + (P.tex ? "_" + P.tex : "")
                  : P.type
                    ? P.tex
                      ? O.types[P.type || 0] + P.id + "_" + P.tex
                      : null
                    : P.tex
                      ? P.tex
                      : "weapons/skins/weapon_" + P.weapon + "_" + P.id
                : UTILS.getReModel(O, P),
            movT: P.movT,
            pulsT: P.pulsT,
            repeatY: P.tileS || 0,
            repeatX: P.tileS || 0,
            frames: P.frames,
            frameT: P.frameT,
            sameGlow: P.sameGlow,
            glowText: P.glow || P.sameGlow,
            emissive: P.glow || P.sameGlow ? 16777215 : null,
            rgb: P.rgb,
            rgbS: P.rgbS,
            rAnim: P.rAnim,
            rAnimA: P.rAnimA,
            wireframe: P.wire,
            side: P.side || 0,
            opacity: P.opac || 1,
            shaderId: P.shaderId,
            itemID: M.itemID || 0,
            shininess: Q.shine || 60,
            specular: 2697513,
            shadowsR: true,
            transparent: P.opac != null || P.trans || Q.seeThrough || false,
          },
          F,
          G,
          H,
          I,
          (M.mSize || 1) * (P.mScl || Q.scale || 1),
          RENDER.scene,
        );
      }
    }
  };
  this.addObjective = function (F, G, H, I, J, K, L) {
    var M;
    if (RENDER) {
      (M = RENDER.addCube(F, G, H, I, K, J, [1, 1, 0, 0, 1, 1], {
        src: "objective_0",
        noGroup: true,
        forceTex: true,
        mat: THREE.MeshBasicMaterial,
        transparent: true,
        depthWrite: false,
        side: 2,
        autoMatrix: true,
      })).visible = false;
    }
    this.objectives.push({
      x: F,
      z: H,
      y: G + K / 2,
      mesh: M,
      width: I / 2,
      length: J / 2,
      height: K / 2,
      objLink: L || 0,
    });
  };
  this.addBombSite = function (F, G, H, I, J, K) {
    var L;
    if (RENDER) {
      (L = RENDER.addCube(F, G + 1, H, I, K, J, [1, 1, 0, 0, 1, 1], {
        src: "objective_b",
        noGroup: true,
        movT: 0.00006,
        forceTex: true,
        shadowsR: true,
        transparent: true,
        depthWrite: false,
        side: 2,
        autoMatrix: true,
      })).visible = false;
    }
    this.sites.push({
      x: F,
      z: H,
      y: G + K / 2,
      meshRef: L,
      width: I / 2,
      length: J / 2,
      height: K / 2,
    });
  };
  this.addDeathZone = function (F, G, H, I, J, K) {
    this.objects.push(
      new GameObject({
        x: F,
        z: H,
        y: G + K / 2,
        w: I / 2,
        l: J / 2,
        h: K / 2,
        kill: true,
        noShoot: true,
        complexMesh: true,
      }),
    );
  };
  this.addScoreZone = function (F, G, H, I, J, K, L) {
    this.objects.push(
      new GameObject({
        x: F,
        z: H,
        y: G + K / 2,
        w: I / 2,
        l: J / 2,
        h: K / 2,
        score: true,
        scoreP: L,
        noShoot: true,
        complexMesh: true,
      }),
    );
  };
  this.addPremiumZone = function (F, G, H, I, J, K, L) {
    this.objects.push(
      new GameObject({
        x: F,
        z: H,
        y: G + K / 2,
        w: I / 2,
        l: J / 2,
        h: K / 2,
        isBorder: L.isBorder,
        noShoot: true,
        complexMesh: true,
        premium: true,
      }),
    );
  };
  this.addVerifiedZone = function (F, G, H, I, J, K, L) {
    this.objects.push(
      new GameObject({
        x: F,
        z: H,
        y: G + K / 2,
        w: I / 2,
        l: J / 2,
        h: K / 2,
        isBorder: L.isBorder,
        noShoot: true,
        complexMesh: true,
        verified: true,
      }),
    );
  };
  this.addTeamZone = function (F, G, H, I, J, K, L) {
    L = L || {};
    this.objects.push(
      new GameObject({
        x: F,
        z: H,
        y: G + K / 2,
        w: I / 2,
        l: J / 2,
        h: K / 2,
        isBorder: L.isBorder,
        noShoot: true,
        complexMesh: true,
        teamZ: true,
        team: L.team,
      }),
    );
  };
  this.addCheckPoint = function (F, G, H, I, J, K, L) {
    L = L || {};
    this.objects.push(
      new GameObject({
        uid: this.objects.length,
        x: F,
        z: H,
        y: G + K / 2,
        w: I / 2,
        l: J / 2,
        h: K / 2,
        d: parseInt(L.direction) || 0,
        checkpoint: true,
        singleUse: L.singleUse,
        noShoot: true,
        complexMesh: true,
        team: L.team,
      }),
    );
  };
  this.addTeleporter = function (F, G, H, I, J, K, L) {
    (L = L || {}).channel = UTILS.limitMM(L.channel, 0, 100);
    var M = new GameObject({
      uid: this.objects.length,
      x: F,
      z: H,
      y: G + K / 2,
      w: I / 2,
      l: J / 2,
      h: K / 2,
      d: parseInt(L.direction) || 0,
      fd: L.forceDir,
      teleporter: true,
      channel: L.channel || 0,
      node: L.node || 0,
      momentum: L.momentum,
      noShoot: true,
      complexMesh: true,
      team: L.team,
    });
    this.objects.push(M);
    this.teleporters.push(M);
  };
  this.addGrass = function (F, G, H, I, J, K, L) {
    L = L || {};
    if (RENDER && !L.noVis) {
      L.side = THREE.DoubleSide;
      L.alphaTest = 0.2;
      L.vertexColors = THREE.VertexColors;
      L.shadowsR = true;
      L.noGroup = !!L.health;
      RENDER.addGrass(F, G, H, I, J, K, L);
    }
  };
  var z = ["#444532", "#484a2f", "#4b4d2e", "#55573b"];
  var A = [
    {
      name: "Tiny Oak",
      height: [30],
      scales: [1.5, 1.6],
      rar: [10],
      gen: function (F, G, H, I) {
        if (RENDER) {
          RENDER.addSphere(F[0], F[1] + G - 1, F[2], 25, 34, 25, {
            src: "default",
            shadows: true,
            vNoise: 0.3,
            xR: H,
            coat: I.cot,
            colr: I.col || z[H % z.length],
          });
        }
      },
    },
    {
      name: "Square Oak",
      height: [65, 50],
      scales: [4, 5],
      rar: [4, 8, 9],
      gen: function (F, G, H, I) {
        if (RENDER) {
          RENDER.addSphere(F[0], F[1] + G - 1, F[2], 110, 120, 110, {
            src: "default",
            shadows: true,
            vNoise: 0.36,
            xR: H,
            coat: I.cot,
            colr: I.col || z[H % z.length],
          });
        }
      },
    },
    {
      name: "Pine",
      height: [90, 120, 140],
      scales: [3, 3.2],
      rar: [5, 6, 7],
      gen: function (F, G, H, I) {
        if (RENDER) {
          var J = F[1] + 40;
          var K = 30;
          for (var L = G >= 130 ? 5 : 4, M = 0; M < L; M++) {
            RENDER.addCone(F[0], J, F[2], K * 2, 40, K * 2, {
              src: "default",
              closC: true,
              xR: H,
              yR: UTILS.randFloat(-0.1, 0.1),
              zR: UTILS.randFloat(-0.1, 0.1),
              vNoise: 0.12,
              sides: 6,
              shadows: true,
              colr: I.col || z[H % z.length],
            });
            K -= 5;
            J += G / L;
          }
        }
      },
    },
    {
      name: "Tall Italian",
      height: [37],
      scales: [3, 3.2],
      rar: [1, 2, 3],
      gen: function (F, G, H, I) {
        if (RENDER) {
          RENDER.addSphere(F[0], F[1] + G - 6, F[2], 39, 80, 39, {
            src: "default",
            shadows: true,
            vNoise: 0.3,
            xR: H,
            coat: I.cot,
            colr: I.col || z[H % z.length],
          });
        }
      },
    },
    {
      name: "Honey Oak",
      height: [100, 120],
      scales: [4, 5],
      rar: [0],
      gen: function (F, G, H, I) {
        if (RENDER) {
          RENDER.addSphere(F[0], F[1] + G - 1, F[2], 70, 80, 70, {
            src: "default",
            shadows: true,
            vNoise: 0.35,
            xR: H,
            coat: I.cot,
            colr: I.col || "#616037",
          });
          RENDER.addCube(
            F[0] + 10,
            F[1] + G / 1.5 + 5,
            F[2],
            22,
            3,
            2,
            [1, 1, 1, 1, 1, 1],
            {
              src: "default",
              colr: "#665547",
              zR: 0.4,
              shadows: true,
              amb: 0.5,
            },
          );
          RENDER.addSphere(F[0] + 20, F[1] + G / 1.5, F[2], 30, 28, 30, {
            src: "default",
            shadows: true,
            vNoise: 0.25,
            coat: I.cot,
            colr: I.col || "#616037",
          });
        }
      },
    },
  ];
  this.addTREE = function (F, G) {
    var H = Math.round(Math.abs((F[0] + F[2]) % 10));
    for (var I = 0; I < A.length; ++I) {
      if (A[I].rar.indexOf(H) >= 0) {
        tmpTree = A[I];
        break;
      }
    }
    if (tmpTree) {
      var J = tmpTree.height[H % tmpTree.height.length] - H * 2;
      var K = tmpTree.scales[H % tmpTree.scales.length];
      if (RENDER) {
        RENDER.addCylinder(F[0], F[1], F[2], K * 1.5, J + 20, K * 1.5, {
          src: "default",
          sides: 4,
          open: true,
          colr: "#524435",
          shadows: true,
          amb: 0.5,
        });
      }
      this.objects.push(
        new GameObject({
          x: F[0],
          z: F[2],
          y: F[1] + J / 2,
          w: K / 2,
          l: K / 2,
          h: J / 2,
          noAmb: true,
          wallJumpable: true,
          uid: this.objects.length,
          penetrable: true,
        }),
      );
      tmpTree.gen(F, J, H, G);
    }
  };
  this.addSTUMP = function (F) {
    if (RENDER) {
      RENDER.addCube(F[0], F[1], F[2], 4, 80, 4, [1, 1, 1, 0, 1, 1], {
        src: "default",
        colr: "#665547",
        shadows: true,
        amb: 0.5,
      });
      RENDER.addCube(F[0], F[1] + 30, F[2] + 10, 2, 3, 22, [1, 1, 1, 1, 1, 1], {
        src: "default",
        colr: "#665547",
        yR: -0.5,
        shadows: true,
        amb: 0.5,
      });
      RENDER.addCube(F[0] + 10, F[1] + 50, F[2], 22, 3, 2, [1, 1, 1, 1, 1, 1], {
        src: "default",
        colr: "#665547",
        zR: 0.4,
        shadows: true,
        amb: 0.5,
      });
    }
    this.objects.push(
      new GameObject({
        x: F[0],
        z: F[2],
        y: F[1] + 40,
        w: 2,
        l: 2,
        h: 40,
        noAmb: true,
        wallJumpable: true,
        uid: this.objects.length,
        penetrable: true,
      }),
    );
  };
  this.addBUSH = function (F, G) {
    var H = F[3];
    var I = Math.round(Math.abs((F[0] + F[2]) % 10));
    var J = H == 2 ? 0.5 : 1;
    if (RENDER) {
      RENDER.addSphere(F[0], F[1] - J * 6, F[2], J * 29, J * 21, J * 28, {
        src: "default",
        colr: G.col || "#646639",
        vNoise: 0.3,
        coat: G.cot,
        xR: I,
        shadows: true,
      });
    }
  };
  var B = [
    {
      name: "Grass",
      scl: 1.2,
      h: [5, 6],
    },
    {
      name: "Flower",
      scl: 0.3,
      h: [2, 2.3],
      gen: function (F, G, H, I) {
        RENDER.addPlane(
          F,
          G + I + 0.05,
          H,
          1.2,
          1.2,
          {
            type: 1,
            src: "default",
            mat: THREE.MeshBasicMaterial,
            shadowsR: true,
            vertexColors: THREE.VertexColors,
            colr: "#993d36",
          },
          UTILS.randFloat(-Math.PI, Math.PI),
          0.5,
          0,
        );
      },
    },
  ];
  this.addGRASS = function (F, G) {
    if (RENDER) {
      F[3];
      for (var H = 0; H < 4; ++H) {
        var I = B[UTILS.randInt(0, 1)];
        var J = F[0] + UTILS.randInt(-15, 15);
        var K = F[2] + UTILS.randInt(-15, 15);
        var L = I.h[UTILS.randInt(0, I.h.length - 1)];
        RENDER.addPlane(
          J,
          F[1],
          K,
          I.scl,
          L,
          {
            type: 1,
            src: "default",
            mat: THREE.MeshBasicMaterial,
            side: THREE.DoubleSide,
            shadowsR: true,
            vertexColors: THREE.VertexColors,
            colr: G.col || "#4d5928",
          },
          UTILS.randFloat(-Math.PI, Math.PI),
          Math.PI / 2,
          0,
        );
        if (I.gen) {
          I.gen(J, F[1], K, L);
        }
      }
    }
  };
  this.addLOOT = function (F) {
    var G = Math.round(Math.abs((F[0] + F[2]) % 3));
    if (RENDER) {
      RENDER.addCube(F[0] + 6, F[1], F[2] + 15, 18, 1, 3, [1, 1, 1, 0, 1, 1], {
        src: "default",
        colr: "#665547",
        xR: 0.86,
        shadows: true,
        amb: 0.5,
      });
    }
    if (G == 0 || G == 1) {
      this.addCylinder(F[0], F[1], F[2], 7, 7, 9, {
        src: "default",
        colr: "#9e2b2b",
        shadows: true,
      });
    }
    if (G == 2 || G == 1) {
      this.addCylinder(F[0] - 7, F[1], F[2] + 12, 7, 7, 9, {
        src: "default",
        colr: "#2b769e",
        shadows: true,
      });
    }
  };
  var C = [
    {
      scl: 25,
      hei: 20,
      nois: 0.2,
      col: "#707070",
    },
    {
      scl: 50,
      hei: 30,
      nois: 0.3,
      col: "#545454",
    },
    {
      scl: 13,
      hei: 10,
      nois: 0.15,
      col: "#707070",
      noCol: true,
    },
    {
      scl: 10,
      hei: 10,
      nois: 0.1,
      col: "#545454",
      noCol: true,
    },
  ];
  this.addROCK = function (F, G) {
    var H = F[1] - 7;
    var I = Math.round(Math.abs((F[0] + F[2]) % 10));
    var J = C[I % C.length];
    if (RENDER) {
      RENDER.addSphere(F[0], H, F[2], J.scl, J.hei, J.scl, {
        src: "default",
        colr: J.col,
        vNoise: J.nois,
        noAmb: true,
        coat: G.cot,
        shadows: true,
      });
    }
    if (!J.noCol) {
      this.objects.push(
        new GameObject({
          x: F[0],
          z: F[2],
          y: H + J.hei / 2,
          w: J.scl / 2,
          l: J.scl / 2,
          h: J.hei / 2,
          uid: this.objects.length,
          wallJumpable: true,
        }),
      );
    }
  };
  this.addTerrObj = function (F, G, H, I) {
    var J = {
      col: null,
      cot: null,
    };
    var K = H.BIOME_INDEXES[F[3]];
    var L = H.MAP_OBJS[G];
    if (L && K) {
      if (L.biomeCoats && L.biomeCoats[K]) {
        J.cot = L.biomeCoats[K];
      }
      if (L.biomeCols && L.biomeCols[K]) {
        J.col = L.biomeCols[K][UTILS.randInt(0, L.biomeCols[K].length - 1)];
      }
    }
    this["add" + G](F, J, I);
  };
  this.addLadder = function (F, G, H, I, J, K) {
    (K = K || {}).src = K.src || "floor_0";
    K.texOffX = UTILS.limitMM(K.texOffX, 0, 1).round(1);
    K.texOffY = UTILS.limitMM(K.texOffY, 0, 1).round(1);
    var L = config.ladderScale;
    var M = config.ladderScale;
    if (J == 0 || J == Math.PI) {
      M = config.ladderWidth;
    } else {
      L = config.ladderWidth;
    }
    x = new GameObject({
      ladder: true,
      complexMesh: true,
      noShoot: true,
      d: J,
      x: F + config.ladderScale * Math.cos(J),
      z: H + config.ladderScale * Math.sin(J),
      y: G + I / 2,
      w: L,
      l: M,
      h: I / 2,
    });
    this.objects.push(x);
    if (RENDER && !K.noVis) {
      K.vertexColors = THREE.VertexColors;
      K.shadows = true;
      K.amb = config.ambientVal;
      K.noEmisTex = true;
      K.transparent = K.src == "link_0" || K.opacity != 1;
      if (K.src == "link_0") {
        K.depthWrite = true;
        K.alphaTest = K.transparent ? 0.02 : 0;
      }
      RENDER.addCube(
        x.x + config.ladderWidth * Math.sin(J),
        x.y - I / 2,
        x.z + config.ladderWidth * Math.cos(J),
        config.ladderScale * 2,
        I + 2,
        config.ladderScale * 2,
        [1, 1, 1, 1, 1, 1],
        K,
      );
      RENDER.addCube(
        x.x - config.ladderWidth * Math.sin(J),
        x.y - I / 2,
        x.z - config.ladderWidth * Math.cos(J),
        config.ladderScale * 2,
        I + 2,
        config.ladderScale * 2,
        [1, 1, 1, 1, 1, 1],
        K,
      );
      for (var N = Math.floor(I / 6), O = 0; O < N; ++O) {
        K.dark = 0.6 + (O / N) * 0.4;
        RENDER.addPlane(
          x.x,
          G + (O + 1) * 6 + UTILS.randFloat(-1, 1),
          x.z,
          config.ladderWidth,
          config.ladderScale,
          K,
          -J + Math.PI / 2,
          Math.PI / 2,
          UTILS.randFloat(-0.1, 0.1),
        );
      }
    }
  };
  this.addRamp = function (F, G, H, I, J, K, L, M) {
    (M = M || {}).src = M.src || "grey_0";
    M.boost &&= UTILS.limit(M.boost, config.boostRange);
    M.texOffX = UTILS.limitMM(M.texOffX, 0, 1).round(1);
    M.texOffY = UTILS.limitMM(M.texOffY, 0, 1).round(1);
    var N = config.ambScale;
    var O = L != 0 && L != Math.PI;
    var P = (O ? K : I) / 2;
    var Q = Math.sqrt(J * J + K * K);
    var R = Math.asin(J / Q);
    this.objects.push(
      new GameObject({
        x: F,
        z: H,
        y: G + J / 2,
        w: I / 2,
        l: K / 2,
        h: J / 2,
        d: L,
        noShoot: true,
        complexMesh: true,
        boostDr: M.boost ? R : null,
        boost: M.boost || null,
        ramp: {
          sX: F - P * Math.cos(L),
          sZ: H - P * Math.sin(L),
          eX: F + P * Math.cos(L),
          eZ: H + P * Math.sin(L),
        },
        noAmb: M.noAmb,
      }),
    );
    if (
      RENDER &&
      !M.noVis &&
      ((M.vertexColors = THREE.VertexColors),
      (M.shadowsR = true),
      (M.side = THREE.DoubleSide),
      (M.noEmisTex = true),
      (M.transparent = M.src == "link_0" || M.opacity != 1),
      M.src == "link_0" &&
        ((M.depthWrite = true), (M.alphaTest = M.transparent ? 0.02 : 0)),
      RENDER.addRamp(F, G, H, O ? I : K, J, (O ? K : I) / 2, L, M),
      !M.noAmb)
    ) {
      G += config.ambOff;
      var S = (O ? I : K) / 2 - N;
      if (O) {
        I = N * 2;
      } else {
        K = N * 2;
      }
      if (!RENDER.noTex) {
        var T;
        for (var U = 0; U < 2; ++U) {
          T = U ? 1 : -1;
          RENDER.addRamp(
            F + S * T * Math.cos(L + Math.PI / 2),
            G,
            H + S * T * Math.sin(L + Math.PI / 2),
            O ? I : K,
            J,
            (O ? K : I) / 2,
            L,
            {
              src: "ambient_1",
              euler: "ZYX",
              depthWrite: false,
              transparent: true,
              side: THREE.DoubleSide,
            },
            U ? 0 : Math.PI,
          );
        }
      }
    }
  };
  this.addGate = function (F, G, H, I, J, K, L) {
    (L = L || {}).src = L.src || "wall_0";
    L.autoMatrix = true;
    L.texOffX = UTILS.limitMM(L.texOffX, 0, 1).round(1);
    L.texOffY = UTILS.limitMM(L.texOffY, 0, 1).round(1);
    L.interface &&= UTILS.limitMM(L.interface, 0, config.interfaceIDMax);
    var M = new GameObject({
      x: F,
      z: H,
      y: G + K / 2,
      w: I / 2,
      l: J / 2,
      h: K / 2,
      uid: this.objects.length,
      src: L.src,
      noVis: L.noVis,
      noAmb: L.noAmb,
      wallJumpable: L.wallJumpable,
      transparent: L.transparent || L.src == "link_0",
      penetrable: L.penetrable,
      isBorder: L.isBorder,
      complexMesh: L.xR || L.yR || L.zR || L.src == "link_0",
      ter: true,
      tRadius: 7,
      gate: true,
      scoreP: L.scoreP,
      noMsg: L.noMsg,
      method: L.method,
      closeable: L.closeable,
      startClosed: L.startClosed && L.closeable,
      interface: L.interface,
      team: L.team,
      type: 0,
    });
    if (RENDER && !L.noVis) {
      L.transparent = L.src == "link_0" || L.opacity != 1;
      if (L.src == "link_0") {
        L.depthWrite = L.opacity == 1;
        L.alphaTest = L.transparent ? 0.02 : 0;
      }
      L.noEmisTex = true;
      L.vertexColors = THREE.VertexColors;
      L.scale = L.scale == null ? 1 : L.scale;
      L.shadows = !L.shadowsR && L.opacity == 1;
      L.noGroup = true;
      var N = RENDER.addCube(F, G, H, I, K, J, [1, 1, 1, 1, 1, 1], L);
      M.meshRef = N;
    }
    this.objects.push(M);
    this.gates.push(M);
    this.addHelpers(L, M.uid);
  };
  this.addBank = function (F, G, H, I, J, K, L) {
    (L = L || {}).src = L.src || "wall_0";
    L.autoMatrix = true;
    L.texOffX = UTILS.limitMM(L.texOffX, 0, 1).round(1);
    L.texOffY = UTILS.limitMM(L.texOffY, 0, 1).round(1);
    L.interface &&= UTILS.limitMM(L.interface, 0, config.interfaceIDMax);
    var M = new GameObject({
      x: F,
      z: H,
      y: G + K / 2,
      w: I / 2,
      l: J / 2,
      h: K / 2,
      uid: this.objects.length,
      src: L.src,
      noVis: L.noVis,
      noAmb: L.noAmb,
      wallJumpable: L.wallJumpable,
      transparent: L.transparent || L.src == "link_0",
      penetrable: L.penetrable,
      isBorder: L.isBorder,
      complexMesh: L.xR || L.yR || L.zR || L.src == "link_0",
      ter: true,
      tRadius: 7,
      bank: true,
      interface: L.interface,
      withdraw: Math.abs(L.withdraw),
      deposit: Math.abs(L.deposit),
      team: L.team,
      type: 0,
    });
    if (RENDER && !L.noVis) {
      L.transparent = L.src == "link_0" || L.opacity != 1;
      if (L.src == "link_0") {
        L.depthWrite = L.opacity == 1;
        L.alphaTest = L.transparent ? 0.02 : 0;
      }
      L.noEmisTex = true;
      L.vertexColors = THREE.VertexColors;
      L.scale = L.scale == null ? 1 : L.scale;
      L.shadows = !L.shadowsR && L.opacity == 1;
      RENDER.addCube(F, G, H, I, K, J, [1, 1, 1, 1, 1, 1], L);
    }
    this.objects.push(M);
    this.banks.push(M);
    this.addHelpers(L, M.uid);
  };
  this.addHelpers = function (F, G) {
    if (!F.noCol) {
      if (F.interface) {
        this.interfaces.push(G);
      }
      if (F.eventN == "onTimer") {
        this.timerObjs.push(G);
      }
    }
  };
  this.addTrigger = function (F, G, H, I, J, K, L) {
    (L = L || {}).src = L.src || "wall_0";
    L.texOffX = UTILS.limitMM(L.texOffX, 0, 1).round(1);
    L.texOffY = UTILS.limitMM(L.texOffY, 0, 1).round(1);
    L.chance = UTILS.limitMM(L.chance, 0, 100);
    L.snd = L.assetSnd
      ? L.snd
      : config.emitterSounds[L.snd]
        ? config.emitterSounds[L.snd]
        : config.emitterSounds[0];
    L.vol = UTILS.limitMM(L.vol, config.emitterVolMin, config.emitterVolMax);
    L.rate = UTILS.limitMM(
      L.rate,
      config.emitterRateMin,
      config.emitterRateMax,
    );
    L.constantEvent = UTILS.limitMM(L.constantEvent, 0, 10000);
    L.interface &&= UTILS.limitMM(L.interface, 0, config.interfaceIDMax);
    if (
      L.constantTxt &&
      L.constantTxt &&
      UTILS.isString(L.constantTxt) &&
      L.constantTxt != ""
    ) {
      if (L.constantTxt.length > 70) {
        L.constantTxt = "";
      }
      if (
        /[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gim.test(L.constantTxt)
      ) {
        L.constantTxt = "";
      }
    } else {
      L.constantTxt = "";
    }
    L.autoMatrix = true;
    if (L.eventN && L.eventN.includes("onAI")) {
      L.eventN = null;
    }
    if (L.health) {
      L.canDestroy = true;
    }
    var M = new GameObject({
      x: F,
      z: H,
      y: G + K / 2,
      w: I / 2,
      l: J / 2,
      h: K / 2,
      uid: this.objects.length,
      src: L.src,
      noVis: L.noVis,
      noAmb: L.noAmb,
      wallJumpable: L.wallJumpable,
      health: L.health,
      canDestroy: L.canDestroy,
      startDestroyed: L.canDestroy && L.startDestroyed,
      selfDestruct: L.selfDestruct && L.singleUse && L.canDestroy,
      respawnT: L.respawnT,
      respawnR: L.respawnR,
      transparent: L.transparent || L.src == "link_0",
      complexMesh: L.xR || L.yR || L.zR || L.src == "link_0",
      ter: true,
      constant: L.constant,
      constantTxt: L.constantTxt,
      constantEvent: L.constantEvent,
      chance: L.chance,
      eventN: L.eventN,
      action: L.action,
      interface: L.interface,
      interfaceT: L.interfaceT,
      tSound: [L.snd, L.vol, L.rate, L.emitfrom, L.assetSnd],
      team: L.team,
      type: 0,
      noShoot: L.eventN == "onEnter",
      singleUse: L.singleUse,
    });
    if (RENDER && !L.noVis) {
      L.transparent = L.src == "link_0" || L.opacity != 1;
      if (L.src == "link_0") {
        L.depthWrite = L.opacity == 1;
        L.alphaTest = L.transparent ? 0.02 : 0;
      }
      L.noEmisTex = true;
      L.vertexColors = THREE.VertexColors;
      L.scale = L.scale == null ? 1 : L.scale;
      L.shadows = !L.shadowsR && L.opacity == 1;
      L.noGroup = !!L.health || !!L.canDestroy;
      var N = RENDER.addCube(F, G, H, I, K, J, [1, 1, 1, 1, 1, 1], L);
      if ((L.health || L.canDestroy) && !L.noCol) {
        M.meshRef = N;
      }
    }
    this.objects.push(M);
    this.addHelpers(L, M.uid);
  };
  this.addTerminal = function (F, G, H, I, J, K, L) {
    (L = L || {}).src = L.src || "wall_0";
    L.autoMatrix = true;
    L.texOffX = UTILS.limitMM(L.texOffX, 0, 1).round(1);
    L.texOffY = UTILS.limitMM(L.texOffY, 0, 1).round(1);
    L.interface &&= UTILS.limitMM(L.interface, 0, config.interfaceIDMax);
    if (L.health) {
      L.canDestroy = true;
    }
    var M = new GameObject({
      x: F,
      z: H,
      y: G + K / 2,
      w: I / 2,
      l: J / 2,
      h: K / 2,
      uid: this.objects.length,
      src: L.src,
      noVis: L.noVis,
      noAmb: L.noAmb,
      health: L.health,
      wallJumpable: L.wallJumpable,
      canDestroy: L.canDestroy,
      startDestroyed: L.canDestroy && L.startDestroyed,
      respawnT: L.respawnT,
      respawnR: L.respawnR,
      transparent: L.transparent || L.src == "link_0",
      complexMesh: L.xR || L.yR || L.zR || L.src == "link_0",
      ter: true,
      tRadius: 7,
      interface: L.interface,
      noMsg: L.noMsg,
      terminal: true,
      team: L.team,
      type: 0,
    });
    if (RENDER && !L.noVis) {
      L.transparent = L.src == "link_0" || L.opacity != 1;
      if (L.src == "link_0") {
        L.depthWrite = L.opacity == 1;
        L.alphaTest = L.transparent ? 0.02 : 0;
      }
      L.noEmisTex = true;
      L.vertexColors = THREE.VertexColors;
      L.scale = L.scale == null ? 1 : L.scale;
      L.shadows = !L.shadowsR && L.opacity == 1;
      L.noGroup = !!L.health || !!L.canDestroy;
      var N = RENDER.addCube(F, G, H, I, K, J, [1, 1, 1, 1, 1, 1], L);
      if ((L.health || L.canDestroy) && !L.noCol) {
        M.meshRef = N;
      }
    }
    this.objects.push(M);
    this.terminals.push(M);
    this.addHelpers(L, M.uid);
  };
  this.addEmitter = function (F, G, H, I) {
    I = I || {};
    if (SOUND) {
      I.snd = I.assetSnd
        ? I.snd
        : config.emitterSounds[I.snd]
          ? config.emitterSounds[I.snd]
          : config.emitterSounds[0];
      I.vol = UTILS.limitMM(I.vol, config.emitterVolMin, config.emitterVolMax);
      I.rate = UTILS.limitMM(
        I.rate,
        config.emitterRateMin,
        config.emitterRateMax,
      );
      I.roll = UTILS.limitMM(
        I.roll,
        config.emitterRollMin,
        config.emitterRollMax,
      );
      I.dist = UTILS.limitMM(
        I.dist,
        config.emitterDistMin,
        config.emitterDistMax,
      );
      SOUND.play3DL(
        I.snd,
        F,
        G,
        H,
        I.vol,
        I.rate,
        I.dist,
        I.roll,
        !!I.assetSnd,
      );
    }
  };
  this.addPointLight = function (F, G, H, I) {
    (I = I || {}).intensity = UTILS.limitMM(I.intensity, 0, 2);
    I.distance = UTILS.limitMM(I.distance, 0, 1000);
    I.decay = UTILS.limitMM(I.decay, 0.1, 2);
    G += 2.5;
    if (!RENDER || !!RENDER.mapDet) {
      if (RENDER) {
        I.noEmisTex = true;
        RENDER.addPointLight(F, G, H, I);
      }
    }
  };
  this.addLightCone = function (F, G, H, I, J, K, L) {
    (L = L || {}).src = L.src || "lightcone_0";
    if (RENDER && !L.noVis) {
      L.noEmisTex = true;
      L.depthWrite = false;
      L.scale = L.scale == null ? 1 : L.scale;
      L.shadows = false;
      L.side = THREE.DoubleSide;
      L.blending = THREE.AdditiveBlending;
      L.mat = THREE.MeshBasicMaterial;
      L.vertexColors = THREE.VertexColors;
      RENDER.addCone(F, G, H, I, K, J, L);
    }
  };
  this.addCylinder = function (F, G, H, I, J, K, L) {
    (L = L || {}).src = L.src || "wall_0";
    L.spin = UTILS.limitMM(L.spin, -20, 20);
    if (L.health) {
      L.canDestroy = true;
    }
    if (!L.noCol) {
      var M = new GameObject({
        x: F,
        z: H,
        y: G + K / 2,
        w: Math.min(I, J) / 2,
        l: Math.min(I, J) / 2,
        h: K / 2,
        uid: this.objects.length,
        src: L.src,
        noVis: L.noVis,
        transparent: L.transparent || L.src == "link_0",
        complexMesh: true,
        ter: true,
        collT: "cylinder",
        spin: L.spin,
        health: L.health,
        canDestroy: L.canDestroy,
        startDestroyed: L.canDestroy && L.startDestroyed,
        respawnT: L.respawnT,
        respawnR: L.respawnR,
        interface: L.interface,
      });
      this.objects.push(M);
      this.addHelpers(L, this.objects.length - 1);
    }
    L.autoMatrix = !!L.health || !!L.canDestroy || L.interface;
    if (RENDER && !L.noVis) {
      L.transparent = L.src == "link_0" || L.opacity != 1;
      if (L.src == "link_0") {
        L.depthWrite = L.opacity == 1;
        L.alphaTest = L.transparent ? 0.02 : 0;
      }
      if (L.open) {
        L.side = THREE.DoubleSide;
      }
      L.noEmisTex = true;
      L.vertexColors = THREE.VertexColors;
      L.scale = L.scale == null ? 1 : L.scale;
      L.shadows = !L.shadowsR && L.opacity == 1;
      L.noGroup = true;
      L.rAnim = (L.spin || 0) * config.diskSpin;
      L.rAnimA = "y";
      var N = RENDER.addCylinder(F, G, H, I, K, J, L);
      if ((L.health || L.canDestroy) && !L.noCol) {
        this.objects[this.objects.length - 1].meshRef = N;
      }
    }
  };
  this.addBlock = function (F, G, H, I, J, K, L, M) {
    (M = M || {}).src = M.src || "wall_0";
    M.gravity = UTILS.limitMM(M.gravity, 0, 5);
    M.texOffX = UTILS.limitMM(M.texOffX, 0, 1).round(1);
    M.texOffY = UTILS.limitMM(M.texOffY, 0, 1).round(1);
    if (M.health) {
      M.canDestroy = true;
    }
    if (!M.noCol) {
      var N = new GameObject({
        x: F,
        z: H,
        y: G + K / 2,
        w: I / 2,
        l: J / 2,
        h: K / 2,
        uid: this.objects.length,
        s: M.sound,
        src: M.src,
        noVis: M.noVis,
        noAmb: M.noAmb,
        health: M.health,
        wallJumpable: M.wallJumpable,
        canDestroy: M.canDestroy,
        startDestroyed: M.canDestroy && M.startDestroyed,
        respawnT: M.respawnT,
        respawnR: M.respawnR,
        transparent: M.transparent || M.src == "link_0",
        penetrable: M.penetrable,
        isBorder: M.isBorder,
        complexMesh: M.xR || M.yR || M.zR || M.src == "link_0",
        ter: true,
        trigger: M.trig,
        interface: M.interface,
        gravity: M.gravity,
        dynamic: M.dynamic,
        type: 0,
      });
      this.objects.push(N);
      this.addHelpers(M, this.objects.length - 1);
    }
    M.autoMatrix = !!M.health || !!M.canDestroy || M.interface;
    if (RENDER && !M.noVis) {
      M.transparent = M.src == "link_0" || M.opacity != 1;
      if (M.src == "link_0") {
        M.depthWrite = M.opacity == 1;
        M.alphaTest = M.transparent ? 0.02 : 0;
      }
      M.noEmisTex = true;
      M.vertexColors = THREE.VertexColors;
      M.scale = M.scale == null ? 1 : M.scale;
      M.shadows = !M.shadowsR && M.opacity == 1;
      M.noGroup = !!M.health || !!M.canDestroy;
      var O = RENDER.addCube(F, G, H, I, K, J, L, M);
      if ((M.health || M.canDestroy) && !M.noCol) {
        this.objects[this.objects.length - 1].meshRef = O;
      }
    }
  };
  this.addSphere = function (F, G, H, I, J, K, L) {
    (L = L || {}).src = L.src || "wall_0";
    L.texOffX = UTILS.limitMM(L.texOffX, 0, 1).round(1);
    L.texOffY = UTILS.limitMM(L.texOffY, 0, 1).round(1);
    if (L.health) {
      L.canDestroy = true;
    }
    if (RENDER && !L.noVis) {
      L.transparent = L.src == "link_0" || L.opacity != 1;
      if (L.src == "link_0") {
        L.depthWrite = L.opacity == 1;
        L.alphaTest = L.transparent ? 0.02 : 0;
      }
      L.noEmisTex = true;
      L.vertexColors = THREE.VertexColors;
      L.scale = L.scale == null ? 1 : L.scale;
      L.shadows = false;
      L.shadowsR = false;
      L.noGroup = !!L.health || !!L.canDestroy;
      L.side = THREE.DoubleSide;
      RENDER.addSphere(F, G, H, I, K, J, L);
    }
  };
  this.addCanvas = function (F, G, H, I, J, K, L, M, N) {
    K = K || {};
    if (RENDER) {
      K.canvas = UTILS.createCanvasText(
        J * 2,
        I * 2,
        K.text || "Hello World",
        K.fontSize || 10,
        K.fcolr || "#000",
        K.bcolr || "#fff",
        K.noBVis,
        K.tAlign || 0,
      );
      K.transparent = true;
      K.depthWrite = true;
      K.alphaTest = 0.02;
      K.side = THREE.DoubleSide;
      K.noShader = true;
      RENDER.addPlane(F, G, H, J, I, K, L, (M || 0) + Math.PI / 2, N);
    }
  };
  this.addSpectateCam = function (F, G, H, I) {
    (I = I || {}).objLink = I.objLink || 0;
    this.spectateCams[I.objLink] ||= [];
    this.spectateCams[I.objLink].push(
      new GameObject({
        x: F,
        z: H,
        y: G + 5,
        xR: I.xR,
        yR: I.yR,
        zR: I.zR,
      }),
    );
  };
  this.addMesh = function (F, G, H, I, J, K, L, M) {
    if ((M = M || {}).mSize) {
      M.mSize = UTILS.limitMM(M.mSize, 0.1, 100);
    }
    G += K;
    x = prefabs.getPrefabByName(M.src.toUpperCase());
    M.interface &&= UTILS.limitMM(M.interface, 0, config.interfaceIDMax);
    if (!RENDER || RENDER.mapDet || !x.noDetail) {
      if (M.health) {
        M.canDestroy = true;
      }
      if (!M.noCol) {
        var N = new GameObject({
          complexMesh: !!x && x.complex,
          aoM: (x && x.aoMlt) || 0,
          propID: x.isProp ? M.src : null,
          x: F,
          z: H,
          y: G,
          w: J,
          l: L,
          h: K,
          uid: this.objects.length,
          ter: true,
          noVis: M.noVis,
          noAmb: M.noAmb,
          health: M.health,
          wallJumpable: M.wallJumpable,
          canDestroy: M.canDestroy,
          startDestroyed: M.canDestroy && M.startDestroyed,
          respawnT: M.respawnT,
          respawnR: M.respawnR,
          interface: M.interface,
          isEvent: M.src.toUpperCase() == "EVENT",
        });
        this.objects.push(N);
        this.addHelpers(M, this.objects.length - 1);
      }
      if (x && x.transparent) {
        G += UTILS.randFloat(-0.01, 0.01);
      }
      if (RENDER && !M.noVis) {
        var O = RENDER.loadMesh(
          {
            src: M.src + "_0",
            emissive: x.emiss ? 16777215 : null,
            opacity: M.opacity,
            side: x.doubleSide ? THREE.DoubleSide : THREE.FrontSide,
            transparent: x.transparent || M.transparent || M.opacity != 1,
            shadows: x.castShadow,
            shadowsR: x.receiveShadow,
            vertexColors: THREE.VertexColors,
            color: M.colr || 16777215,
            noGroup: !!M.health || !!M.canDestroy,
            backup: [J, L, K],
            mat: M.mat,
            frames: x.frames ? x.frames : undefined,
            frameT: x.frameT ? x.frameT : undefined,
            alphaTest: x.alphaTest || 0,
          },
          F,
          G,
          H,
          I,
          M.mSize || x.scale,
          RENDER.scene,
          !M.health && !M.canDestroy,
        );
        if ((M.health || M.canDestroy) && !M.noCol) {
          this.objects[this.objects.length - 1].meshRef = O;
        }
      }
    }
  };
  this.addAsset = function (F, G, H, I, J, K, L, M) {
    if ((M = M || {}).mSize) {
      M.mSize = UTILS.limitMM(M.mSize, 0.1, 100);
    }
    G += K;
    x = prefabs.getPrefabByName("CUSTOM_ASSET");
    var N = M.asset.includes("e");
    var O = M.asset.includes("n");
    var P = M.asset.includes("s");
    var Q = M.asset.includes("a");
    var R = M.asset.includes("g");
    M.spin = UTILS.limitMM(M.spin, -20, 20);
    if (M.spin != 0) {
      M.rAnim = (M.spin || 0) * config.diskSpin;
      M.rAnimA = "y";
    }
    M.interface &&= UTILS.limitMM(M.interface, 0, config.interfaceIDMax);
    if (M.health) {
      M.canDestroy = true;
    }
    if (!M.noCol) {
      this.objects.push(
        new GameObject({
          complexMesh: true,
          aoM: 0,
          propID: null,
          x: F,
          z: H,
          y: G,
          w: J,
          l: L,
          h: K,
          uid: this.objects.length,
          ter: true,
          noVis: M.noVis,
          noAmb: M.noAmb,
          health: M.health,
          wallJumpable: M.wallJumpable,
          canDestroy: M.canDestroy,
          startDestroyed: M.canDestroy && M.startDestroyed,
          respawnT: M.respawnT,
          respawnR: M.respawnR,
          interface: M.interface,
          asset: M.asset,
        }),
      );
    }
    this.addHelpers(M, this.objects.length - 1);
    if (x && x.transparent) {
      G += UTILS.randFloat(-0.01, 0.01);
    }
    if (RENDER && !M.noVis) {
      var S = (M.asset || "").replace(/[^\d]/g, "");
      var T = RENDER.loadMesh(
        {
          fileExt: R ? "gltf" : null,
          src: S + "/" + M.src,
          emissive: N ? 16777215 : null,
          opacity: M.opacity,
          transparent: M.transparent || M.opacity != 1,
          shadows: true,
          shadowsR: true,
          vertexColors: THREE.VertexColors,
          colr: M.colr || 16777215,
          noGroup: !!M.health || !!M.canDestroy,
          backup: [J, L, K],
          normal: O,
          spec: P,
          alphaTest: Q ? 0.02 : 0,
          asset: S,
          tFilter: M.noSmooth ? THREE.NearestFilter : THREE.LinearFilter,
          rAnim: M.rAnim,
          rAnimA: M.rAnimA,
        },
        F,
        G,
        H,
        I,
        M.mSize || 1,
        RENDER.scene,
        !M.health && !M.canDestroy && !M.spin,
      );
      if ((M.health || M.canDestroy) && !M.noCol) {
        this.objects[this.objects.length - 1].meshRef = T;
      }
    }
  };
  this.addAI = function (F, G, H, I, J, K, L, M) {
    if (!RENDER && !(this.pendingAIs.length >= 20)) {
      if ((M = M || {}).mSize) {
        M.mSize = UTILS.limitMM(M.mSize, 0.1, 100);
      }
      M.speed = UTILS.limitMM(M.speed, 0, 5);
      M.turnSpd = UTILS.limitMM(M.turnSpd, 0, 30);
      M.grv = UTILS.limitMM(M.grv, 0, 1);
      M.frate = UTILS.limitMM(M.frate, 200, 10000);
      M.visDis = UTILS.limitMM(M.visDis, 1, 1000);
      M.score = UTILS.limitMM(M.score, 0, 10000);
      M.proj = UTILS.limitMM(M.proj, 0, 5);
      M.behav = UTILS.limitMM(M.behav, 0, 20);
      M.reward = UTILS.isString(M.reward) ? M.reward.split(",") : null;
      M.interface = 0;
      M.eventN = M.canTrigger ? M.eventN : null;
      if (M.aiName && UTILS.isString(M.aiName) && M.aiName != "") {
        if (M.aiName.length > 16) {
          M.aiName = "Bot";
        }
        if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gim.test(M.aiName)) {
          M.aiName = "Bot";
        }
      } else {
        M.aiName = "Bot";
      }
      M.constantEvent = UTILS.limitMM(M.constantEvent, 0, 10000);
      M.chance = UTILS.limitMM(M.chance, 0, 100);
      if (
        M.constantTxt &&
        M.constantTxt &&
        UTILS.isString(M.constantTxt) &&
        M.constantTxt != ""
      ) {
        if (M.constantTxt.length > 70) {
          M.constantTxt = "";
        }
        if (
          /[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gim.test(M.constantTxt)
        ) {
          M.constantTxt = "";
        }
      } else {
        M.constantTxt = "";
      }
      if (M.eventN && !M.eventN.includes("onAI")) {
        M.eventN = null;
      }
      this.pendingAIs.push({
        data: M,
        x: F,
        y: G,
        z: H,
        r: I,
        w: J,
        h: K,
        l: L,
      });
    }
  };
  this.addPendingAIs = function (F) {
    for (var G = 0; G < this.pendingAIs.length; ++G) {
      var H = (x = this.pendingAIs[G]).data;
      if (H) {
        F.spawn(null, 0, H.aiName, x.x, x.y, x.z, H);
      }
    }
  };
  var D = [];
  this.addNoisePlanes = function () {
    for (var F = 0; F < D.length; ++F) {
      D[F][5].objects = this.objects;
      var G = RENDER.addPlane(...D[F]);
      if (D[F].length == 10) {
        this.objects[D[F][9]].meshRef = G;
      }
    }
    D.length = 0;
  };
  this.addPlane = function (F, G, H, I, J, K, L, M, N) {
    if ((K = K || {}).texOffX) {
      K.texOffX = UTILS.limitMM(K.texOffX, 0, 1).round(1);
    }
    K.texOffY &&= UTILS.limitMM(K.texOffY, 0, 1).round(1);
    K.interface &&= UTILS.limitMM(K.interface, 0, config.interfaceIDMax);
    if (K.health) {
      K.canDestroy = true;
    }
    if (!K.noCol) {
      this.objects.push(
        new GameObject({
          x: F,
          z: H,
          y: G,
          w: J,
          l: I,
          h: 0,
          uid: this.objects.length,
          s: K.sound,
          health: K.health,
          wallJumpable: K.wallJumpable,
          respawnT: K.respawnT,
          respawnR: K.respawnR,
          transparent: K.transparent || K.src == "link_0",
          penetrable: K.penetrable,
          noVis: K.noVis,
          noAmb: K.noAmb,
          interface: K.interface,
          showAd: K.showAd,
          canDestroy: K.canDestroy,
          startDestroyed: K.canDestroy && K.startDestroyed,
        }),
      );
    }
    if (!K.noCol && !K.showAd && !K.noise && K.side != 2 && !K.asset) {
      this.objects[this.objects.length - 1].type = 1;
    }
    this.addHelpers(K, this.objects.length - 1);
    if (RENDER && !K.noVis) {
      if (K.showAd) {
        K.bgCol = K.bgCol || "#000000";
        K.textCol = K.textCol || "#e3e3e3";
        K.text = K.text || "Your Ad Here";
        if (K.text.indexOf("discord") >= 0 || K.text.indexOf("gg") >= 0) {
          K.text = "Your Ad Here";
        }
        K.canvas = UTILS.createCanvasAD(K.text, K.textCol, K.bgCol);
      }
      K.noEmisTex = true;
      K.transparent = true;
      K.side = THREE.DoubleSide;
      K.vertexColors = THREE.VertexColors;
      K.noGroup = !!K.health || !!K.canDestroy;
      K.shadowsR = true;
      if (K.noise) {
        K.pinEdges = true;
        K.margin = 5;
        K.tilesX = Math.round(J / 5);
        K.tilesZ = Math.round(I / 5);
      }
      K.noShader = !!K.noise;
      var O = [F, G, H, J, I, K, L, (M || 0) + Math.PI / 2, N];
      if (K.noise) {
        if ((K.health || K.canDestroy) && !K.noCol) {
          O.push(this.objects.length - 1);
        }
        D.push(O);
      } else {
        var P = RENDER.addPlane(...O);
        if ((K.health || K.canDestroy) && !K.noCol) {
          this.objects[this.objects.length - 1].meshRef = P;
        }
      }
    }
  };
  this.addLiquid = function (F, G, H, I, J, K, L, M, N) {
    if (RENDER && !K.noVis && RENDER.mapDet) {
      (K = K || {}).texOffX = UTILS.limitMM(K.texOffX, 0, 1).round(1);
      K.texOffY = UTILS.limitMM(K.texOffY, 0, 1).round(1);
      K.noEmisTex = true;
      K.shadowsR = true;
      K.transparent = true;
      K.side = THREE.DoubleSide;
      K.scale = 2;
      K.vertexColors = THREE.VertexColors;
      K.noGroup = true;
      K.tilesX = K.tilesX || 10;
      K.tilesZ = K.tilesZ || 10;
      K.noShader = true;
      K.mat = THREE.StrippedLambertMaterial;
      var O = RENDER.addPlane(F, G, H, J, I, K, L, (M || 0) + Math.PI / 2, N);
      RENDER.liquids.push({
        mesh: O,
        spd: K.wSpeed || 10,
        hght: K.wHeight || 0.5,
      });
    }
  };
  this.pointInObjs = function (F, G, H) {
    for (var I = 0; I < this.objects.length; ++I) {
      if (
        !(x = this.objects[I]).noVis &&
        !x.complexMesh &&
        !x.health &&
        !x.canDestroy &&
        G.indexOf(x.sid) < 0 &&
        UTILS.pointInBox3D(F[0], F[1], F[2], x, H || 0)
      ) {
        return true;
      }
    }
    return false;
  };
  this.setMaxAO = function (F, G, H) {
    F.maxAOS = F.maxAOS || {};
    F.maxAOS[G.sid] = Math.max(H, F.maxAOS[G.sid] || 0);
    G.maxAOS = G.maxAOS || {};
    G.maxAOS[F.sid] = Math.max(H, G.maxAOS[F.sid] || 0);
  };
  this.aosToAdd = {};
  this.addAmbient = function (F, G, H, I, J, K, L, M, N, O, P) {
    if (!RENDER.noTex) {
      var Q = !O;
      if (O) {
        for (var R = 0; R < O.length; ++R) {
          if (UTILS.pointInBox3D(F, G, H, O[R], config.ambOff * 2)) {
            Q = true;
            break;
          }
        }
      }
      if (Q) {
        if (O) {
          var S = O[0].sid + "-" + O[1].sid;
          this.aosToAdd[S] ||= [];
          this.aosToAdd[S].push({
            vals: [F, G, H, I, J, K, L + config.ambOff, M + config.ambOff, N],
            group: P,
          });
        } else {
          this.addPlane(
            F,
            G,
            H,
            L,
            M,
            {
              src: "ambient_" + (N || 0),
              euler: "ZYX",
              depthWrite: false,
              noCol: true,
            },
            I,
            J,
            K,
          );
        }
      }
    }
  };
  var E = [
    ["g6-1-2", "g4-1-2"],
    ["g5-1-2", "g4-0-1"],
    ["g6-0-1", "g3-1-2"],
    ["g5-0-1", "g3-0-1"],
    ["g6-0-3", "g2-0-3"],
    ["g5-0-3", "g2-1-1"],
    ["g6-1-1", "g1-0-3"],
    ["g5-1-1", "g1-1-1"],
    ["g6-0-2", "g1-1-0"],
    ["g5-0-2", "g1-0-2"],
    ["g6-1-0", "g2-1-0"],
    ["g5-1-0", "g2-0-2"],
    ["g4-0-2", "g1-0-0"],
    ["g3-0-2", "g1-1-3"],
    ["g4-1-0", "g2-0-0"],
    ["g3-1-0", "g2-1-3"],
    ["g4-0-3", "g2-1-2"],
    ["g3-0-3", "g2-0-1"],
    ["g4-1-1", "g1-1-2"],
    ["g3-1-1", "g1-0-1"],
    ["g6-1-3", "g3-0-0"],
    ["g5-1-3", "g3-1-3"],
    ["g6-0-0", "g4-0-0"],
    ["g5-0-0", "g4-1-3"],
  ];
  this.groupsMatch = function (F, G) {
    for (var H = 0; H < E.length; ++H) {
      if (E[H].indexOf(F) >= 0 && E[H].indexOf(G) >= 0) {
        return true;
      }
    }
    return false;
  };
  this.clearAOGroup = function (F) {
    for (var G = F.length - 1; G >= 0; --G) {
      x = F[G];
      for (var H = F.length - 1; H >= 0; --H) {
        y = F[H];
        if (
          !x.dontAdd &&
          !y.dontAdd &&
          x != y &&
          this.groupsMatch(x.group, y.group)
        ) {
          if (x.vals[6] + x.vals[7] >= y.vals[6] + y.vals[7]) {
            y.dontAdd = true;
          } else {
            x.dontAdd = true;
          }
          break;
        }
      }
    }
  };
  this.addPendingAOs = function () {
    for (var F in this.aosToAdd) {
      if (this.aosToAdd.hasOwnProperty(F)) {
        this.clearAOGroup(this.aosToAdd[F]);
        for (var G = 0; G < this.aosToAdd[F].length; ++G) {
          if (!this.aosToAdd[F][G].dontAdd) {
            this.addAmbient(...this.aosToAdd[F][G].vals);
          }
        }
      }
    }
    this.aosToAdd = {};
  };
  this.limitAmb = function (F, G, H, I, J, K, L) {
    var M = [UTILS.cdv[I]];
    var N = [UTILS.cdv[J]];
    return (F =
      H == -Math.PI / 2 || H == Math.PI + Math.PI / 2
        ? Math.min(F, (G[J] - Math.min(K[J] - K[N], L[J] - L[N])) / 2)
        : H == Math.PI / 2
          ? Math.min(F, (Math.max(K[J] + K[N], L[J] + L[N]) - G[J]) / 2)
          : H == 0
            ? Math.min(F, (Math.max(K[I] + K[M], L[I] + L[M]) - G[I]) / 2)
            : Math.min(F, (G[I] - Math.min(K[I] - K[M], L[I] - L[M])) / 2));
  };
  this.resetAll = function () {
    this.aosToAdd = {};
    this.destObjs.length = 0;
    var F;
    for (var G = 0; G < this.objects.length; ++G) {
      F = !this.objects[G].startClosed && !this.objects[G].startDestroyed;
      if (
        (this.objects[G].health || this.objects[G].canDestroy) &&
        this.objects[G].startDestroyed
      ) {
        this.objects[G].destroyed = true;
        this.objects[G].active = false;
        this.destObjs.push(this.objects[G].uid);
      } else {
        this.objects[G].destroyed = !!this.objects[G].startDestroyed;
        this.objects[G].active = F;
      }
      if (this.objects[G].startHealth) {
        this.objects[G].health = this.objects[G].startHealth;
      }
      this.objects[G].storage = 0;
      this.objects[G].triggered = false;
      if (this.objects[G].meshRef) {
        this.objects[G].meshRef.visible = F;
      }
    }
    if (RENDER) {
      RENDER.updateShadowMap();
    }
  };
  this.removeAll = function () {
    this.objects.length = 0;
    this.grids = {};
    this.objectives.length = 0;
    this.sites.length = 0;
    this.flags.length = 0;
    this.spawnables.length = 0;
    this.pickups.length = 0;
    this.gates.length = 0;
    this.banks.length = 0;
    this.terminals.length = 0;
    this.pendingAIs.length = 0;
    this.teleporters.length = 0;
    this.timerObjs.length = 0;
    this.spectateCams = {};
  };
};
